import {ChangeDetectorRef, Component} from '@angular/core';
import {CartService} from "../../../../services/CartService";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {OrderService} from "../../../../services/OrderService";

@Component({
  selector: 'app-cart-action',
  templateUrl: './cart-action.component.html',
  styleUrls: ['./cart-action.component.css']
})
export class CartActionComponent {

    public cartData: object;

    constructor(public cartService:CartService, public modelToolsProvider:ModelToolsProvider, public orderService:OrderService,
                private changeRef: ChangeDetectorRef,) {
    }

    ngOnInit() {
      this.cartData = this.cartService.getCartData();
    }


    cancelAction() {
        let me = this;
        this.modelToolsProvider.yesOrNoAlert(function () {
            me.orderService.cancelAction();
            me.changeRef.detectChanges();
        })
    }

}
